var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-phone-box",class:{ h32: _vm.height === '32px' }},[_c('el-input',_vm._g(_vm._b({staticClass:"input-phone",attrs:{"clearable":""}},'el-input',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }